import {fr} from "@codegouvfr/react-dsfr";
import React from "react";

export const OfaMessageBanner = ({ title, subtitle }: OfaMessageBannerProps) => {
  return (
    <div
      className={'flex flex-col p-4 bg-[#EEE] relative ofa-message-banner'}>

      <i className={fr.cx('fr-icon-info-line')} />

      <div className={'flex flex-col gap-2 py-4 px-8'}>

        <h5 className={'m-0!'}>{title}</h5>

        <span>{subtitle}</span>
      </div>
    </div>
  );
};

interface OfaMessageBannerProps {
  title: string;
  subtitle: string;
}